import { useApi } from "@/lib/hooks";

/**
 * The bell's unread marker. Every top bar rendered it unconditionally, so it
 * never cleared (audit FE-27). useApi refetches on data:changed, which
 * marking notifications read emits.
 */
export default function NotificationDot() {
  const { data } = useApi<{ unread_count?: number }>("/v1/jcontrol/notifications/unread-count");
  return (data?.unread_count ?? 0) > 0 ? <span className="dot" /> : null;
}
